import React, { Component } from 'react'
import cn from 'classnames'

import { LayoutColumn } from 'client/shared/blocks/layout-column'
import SubHeaderNavBox from 'client/bookmate/boxes/sub-header-nav-box'
import SubHeaderPreview from '../sub-header-preview'

import { SubHeaderProps } from '../sub-header'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  isFixed: boolean
  isVisible: boolean
  query?: QueryParams
  isMobileSize: () => boolean
} & SubHeaderProps

export class SubHeaderDefault extends Component<Props> {
  render(): JSX.Element {
    const {
      isFixed = false,
      isVisible = false,
      previewLink,
      title,
      authors,
      renderCover,
      renderButton,
      nav,
      hidden,
      kind,
      isMobileSize,
      query,
    } = this.props

    const subHeaderClasses = cn('sub-header', {
      [`sub-header_${kind}`]: kind,
      'sub-header_preview-visible': !hidden && isVisible,
    })

    return (
      <div className={subHeaderClasses}>
        <div
          className={cn(
            'sub-header__content',
            isFixed && !isMobileSize() && 'sub-header__content_fixed',
          )}
        >
          {!isMobileSize() && (
            <SubHeaderPreview
              previewLink={previewLink}
              title={title}
              authors={authors}
              renderCover={renderCover}
              renderButton={renderButton}
              visible={!hidden && isVisible}
              kind={kind}
              query={query}
            />
          )}

          <LayoutColumn>
            <SubHeaderNavBox nav={nav} includeSubpaths={kind === 'user'} />
          </LayoutColumn>
        </div>
      </div>
    )
  }
}
